<template>
    <div id="scroll-div" class="overflow-y-auto">
        <div v-for="(message, index) in messages" :key="index">
          <div class="chat-content" v-if="message.author == 'user'" >
            <ClientMessage :content="message"/>
          </div>
          <div class="chat-content" v-else>
            <BotMessage :content="message"/>
          </div>  
        </div>
    </div>
</template>
<script>
import ClientMessage from '../Messages/ClientMessage'
import BotMessage from '../Messages/BotMessage'

export default {
  components: {
    ClientMessage,
    BotMessage
  },
  data: () => ({
    // messages: []
  }),
  computed: {
    messages() {
      return this.$store.getters['message/get_messages']
    }
  },
  watch: {
    message(newMessage) {
      this.messages.push(newMessage)
      
    }
  },
  updated(){  
      let div = this.$el
      div.scrollTop = div.scrollHeight;
  }
}
</script>
<style lang="scss">
  .chat-content {
    display: flow-root;
    margin: 5px 0px;
    padding: 0px;
  }
  #scroll-div {
    
    overflow-y: hidden;
    height:400px;
  }
</style>